import React from "react";

import profile_pic from "../../assets/profile-pic.jpeg";
import { ReactComponent as WhatsappIcon } from "../../assets/whatsapp.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/linkedin.svg";
import { ReactComponent as GmailIcon } from "../../assets/gmail.svg";
import { ReactComponent as WaveHandIcon } from "../../assets/wave-hand-emoji.svg";

import "./AboutMe.scss";
import useScreenWidth from "../../hooks/useScreenResizeEvent";

const PhotoContent = ({ customClass }: { customClass?: string }) => (
  <div className={"photo-contact " + customClass || ''}>
    <div className="photo">
      <img src={profile_pic} alt="Swapnil Shah" height={300} width={300} />
    </div>
    <div className="contact-handles">
      {/* <span>
              <WhatsappIcon />
            </span> */}
      <span>
        <a href="mailto:swapnil.shah1996@gmail.com">
          <GmailIcon />
        </a>
      </span>
      <span>
        <a href="https://www.linkedin.com/in/shah-swapnil">
          <LinkedinIcon />
        </a>
      </span>
    </div>
  </div>
);

const AboutMe = () => {
  const screenWidth = useScreenWidth();
  return (
    <div className="about-me">
      {screenWidth < 641 ? <PhotoContent customClass="mobile-view" /> : null}
      <div className="top">
        <div className="intro">
          <p>
            Hey, I am Swapnil <WaveHandIcon />
          </p>
          <p>Developer, Innovator, and Explorer</p>
          <p>
            I'm a passionate software engineer who loves building innovative web
            applications and exploring new technologies. From crafting chatbot
            solutions with Dialogflow to designing video streaming pipelines,
            creating data systems, and architecting web applications, I've
            delved into a diverse range of projects.
          </p>
        </div>
        {screenWidth >= 641 ? <PhotoContent /> : null}
      </div>
      <div className="bottom">
        <p>
          Currently, I work as a technical lead, architecting virtual agent
          solutions and guiding a talented team of professionals to deliver
          impactful results. Beyond my professional role, I'm an avid learner
          who enjoys creating side projects, like dialogflow-webhook-parser, and
          even designed this very website! My foray into Figma taught me the
          importance of design systems and user experience, which I now
          integrate into my work.
        </p>
        <p>
          When I'm not coding, you'll find me experimenting with new ideas,
          constantly pushing the boundaries of what's possible.
        </p>
      </div>
    </div>
  );
};

export default AboutMe;
